import React from "react";
import { SearchItem } from "./SearchItem";
import Pagination from "../Paging/Pagination";
import { useState, useEffect } from "react";
import severUrl from "../../api";
import sortup from "../../assets/images/sortcom.png";
import sortdown from "../../assets/images/sortcomdown.png";
import { useSelector, useDispatch } from "react-redux";
import { connect } from 'react-redux';
import { addTodo, listTodo, listPost, addPostList } from '../../redux/_actions/post.action';
import axios from "axios";
import { DummyItem } from "./DummyItem";

const options = { //Typescript ways of adding the type
    year: "numeric",
    month: "long",
};

// class SearchList extends React.Component {
//   state = {
//     posts: [
//       { title: 'post 1', id: 1 },
//       { title: 'post 3', id: 3 },
//       { title: 'post2', id: 2 },
//       { title: 'post5', id: 5 },
//     ],
//     tags: [],
//     currentPage: 0,
//     totalPages: 0,
//     presences: [],
//     desc: false,
//     sortState: false,
//     loaded: false,
//   };

//   componentDidMount() {

//     var bodyFormData = new FormData();
//     bodyFormData.append("currentPage", 1);
//     bodyFormData.append("numberPerPage", 10);

//     try {
//       // const data = await fetchData('https://api.example.com/data');
//       // this.setState({ data, loading: false });
//       axios.post(severUrl + "blog/list/current/", bodyFormData).then((response) => response.data)
//         .then((data) => {
//           this.setState({posts: data.data});
//           console.log(data.data)
//           this.setState({ loaded: true })
//           this.setState({ currentPage: 0 });

//         })

//     } catch (error) {
//       //this.setState({ error, loading: false });
//     }


//     const choice = this.state.posts.slice(0, 3);
//     this.setState({ presences: [...choice] });
//     console.log(this.state.presences)

//   }

//   onSort = (desc) => {
//     if (this.state.desc) {
//       this.state.posts.sort(function (a, b) {
//         return new Date(a.created_on) - new Date(b.created_on)
//       });
//     } else {
//       this.state.posts.sort(function (a, b) {
//         return new Date(b.created_on) - new Date(a.created_on)
//       });
//     }
//     this.setState({ post: [...this.state.posts] });
//     this.setState({ desc: !this.state.desc });
//   };

//   render() {
//     return (
//       <>
//       <div style={{marginTop:"100px"}}>
//         <button onClick={() => this.onSort()}>Sort</button>
//         <ul>
//           {this.state.posts &&
//             Array.from(this.state.presences).map((pst, index) => {
//               return <li>{pst.post_id}</li>;
//             })}
//         </ul>
//         </div>
//       </>
//     );
//   }
// }

// export default SearchList;

class MobileSearchList extends React.Component {

    constructor(props) {
        super(props);
        this.props = props
    }

    state = {
        posts: [],
        tags: [],
        currentPage: 0,
        totalPages: 0,
        presences: [],
        desc: true,
        sortState: false,
        loaded: false,
        showReloadIndicator: false
    };

    componentDidMount() {

        if (localStorage.getItem("search_list") == null) {
            this.setState({showReloadIndicator: true})
        }

        this.setState({ posts: [...this.props.slist] })

        console.log(this.state.posts)
        console.log(this.props.slist.post)
        localStorage.removeItem("key");
        localStorage.removeItem("search_list");

    }

    componentWillUnmount() {
        localStorage.removeItem("key");
        localStorage.removeItem("search_list");
    }

    render() {

        return (
            <>
                <div style={{ display: "block", height:"100vh" }}>


                    {
                        Array.from(this.state.posts)
                            .map((value, index) => {

                                return (
                                    <li style={{marginBottom:"10px"}}><a href={value.slug}>{value.title}</a></li>)

                                    // return (
                                    //     <SearchItem
                                    //       data={{
                                    //         thumnail: pst.ava,
                                    //         title: pst.post_title,
                                    //         description: pst.post_abstract,
                                    //         tag: pst.tags,
                                    //         slug: pst.slug,
                                    //         ava: null,
                                    //         created: new Date(pst.created_on).toLocaleDateString([], options),
                                    //         mavail: null,
                                    //         currVer: pst.ver,
                                    //         authors: pst.authors
                                    //       }}
                                    //     />)


                            })

                    }



                </div>
            </>
        );
    }
}

export default MobileSearchList;


